import { render, staticRenderFns } from "./getOrgList.vue?vue&type=template&id=334c56c2&scoped=true"
import script from "./getOrgList.vue?vue&type=script&lang=js"
export * from "./getOrgList.vue?vue&type=script&lang=js"
import style0 from "./getOrgList.vue?vue&type=style&index=0&id=334c56c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334c56c2",
  null
  
)

export default component.exports